import React, { useState } from 'react'
import ItemQuantity from './item-quantity'
import DiscountModal from "./discount-modal"
import USD from "../../../components/usd"
import { calcItemPrice, buildProductOfItem } from "../../../shop/common"

export default function Item (props) {
  const {products, item, index, setQuantityControl, showQuantityControl} = props
  const [showModal, setShowModal] = useState(false)
  const openModal = () => {
    setShowModal(true)
  }
  const closeModal = () => {
    setShowModal(false)
  }

  const product = buildProductOfItem(products, item)
  const quantity = item.quantity || 1;

  return (
    <tr
      className='shop-cart-row'
      key={product.id}
      onClick={setQuantityControl}
    >
      <td className='shop-cart-row__name'>
        {showQuantityControl ?
          <ItemQuantity value={item.quantity}
            title={product.full_title || product.title}
            onClickMinus={e => {e.stopPropagation(); props.decreaseItem(item, index)}}
            onClickPlus={e => {e.stopPropagation(); props.increaseItem(item, index)}}
          />
          :
          <span onClick={setQuantityControl}> {/* Safari fix */}
            {item.quantity && `(${item.quantity}) `}
            {product.full_title || product.title}
          </span>
        }
        {props.showDiscountPerItem &&
          <span className='shop-cart-row__discount' onClick={openModal}>
            <i className="shop-cart__pencil"></i>
          </span>
        }
        {item.discount && 
          <span className='shop-cart-row__dicount-value'>
            {item.discount.type == 'amount' ? `$${item.discount.amount}` : `${item.discount.amount}%`}
          </span>}
        {showModal &&
        <DiscountModal onRequestClose={closeModal}
                       onSetDiscount={props.onSetDiscount}
                       onCorrectDiscount={props.onCorrectDiscount}
        />
      }
      </td>
      <td className='shop-cart-row__cost'>
        <USD val={calcItemPrice(item, product, quantity).amount}/>
      </td>
    </tr>
  )
}
